import type { PageKey } from '@youkuai/contracts';

export interface ManagementLink { page: PageKey; to: string; label: string }

const managementLinks: readonly ManagementLink[] = [
  { page: 'PEOPLE', to: '/people', label: '人员档案' },
  { page: 'CUSTOMERS', to: '/customers', label: '客户档案' },
  { page: 'SERVICE_TEMPLATES', to: '/service-templates', label: '服务模板与费率' },
  { page: 'SYSTEM', to: '/system/accounts', label: '账号管理' },
  { page: 'SYSTEM', to: '/system/roles', label: '角色与页面权限' },
  { page: 'SYSTEM', to: '/system/mcp-access', label: 'MCP 权限' },
  { page: 'SYSTEM', to: '/operations/outbox', label: '消息重放' },
  { page: 'SYSTEM', to: '/operations/export-grants', label: '导出授权' },
];

export function managementLinksFor(pageAccess: readonly PageKey[]): readonly ManagementLink[] {
  const allowed = new Set(pageAccess);
  return managementLinks.filter((link) => allowed.has(link.page));
}

const projectRoutes: ReadonlyArray<[RegExp, PageKey]> = [
  [/\/packages$/, 'PROJECT_PACKAGES'], [/\/content$/, 'PROJECT_CONTENT'],
  [/\/deliveries$/, 'PROJECT_DELIVERIES'], [/\/publications$/, 'PROJECT_PUBLICATIONS'],
  [/\/work-expenses$/, 'PROJECT_WORK_EXPENSES'], [/\/changes$/, 'PROJECT_CHANGES'],
  [/\/operations$/, 'PROJECT_FINANCE'], [/\/contracts$/, 'PROJECT_CONTRACTS'],
  [/\/team$/, 'PROJECT_MEMBERS'], [/\/settings$/, 'PROJECT_SETTINGS'],
];

export function pageForWebPath(path: string): PageKey | null {
  if (path === '/workspace' || path === '/workspace/output') return 'WORKSPACE';
  if (path === '/management-dashboard') return 'MANAGEMENT_DASHBOARD';
  if (path === '/me/payee' || path === '/me/ai-access') return 'WORKSPACE';
  if (path === '/projects' || path === '/projects/new' || /^\/projects\/[^/]+$/.test(path)) return 'PROJECTS';
  if (path === '/contracts') return 'CONTRACTS';
  if (path === '/operations/settlement' || path === '/operations/bank-accounts') return 'SETTLEMENTS';
  if (path === '/people') return 'PEOPLE';
  if (path === '/customers') return 'CUSTOMERS';
  if (path === '/service-templates') return 'SERVICE_TEMPLATES';
  if (path.startsWith('/system/') || path === '/operations/outbox' || path === '/operations/export-grants') return 'SYSTEM';
  if (path.startsWith('/projects/')) for (const [pattern, page] of projectRoutes) if (pattern.test(path)) return page;
  return null;
}
